<template>
  <div>
    <div>
      <Dialog
        :id="'dialogWilliamHill'"
        titulo="William Hill"
        ref="dialogWilliamHill"
        :modal="true"
        :hideHeader="false"
        tamanho="lg"
        :noClassFooter="true"
      >
        <div
          class="row mb-2"
          :style="{ display: view == 'opcoes' ? 'block' : 'none' }"
        >
          <div class="col">
            <h2 class="mt-2 mb-2">
              {{ mensagem }}
            </h2>
            <div class="mb-1">
              <button
                type="button"
                class="btn btn-sm btn-secondary mr-2"
                @click="williamHillVincular()"
              >
                Vincular eventos
              </button>
            </div>
            <div>
              <button
                type="button"
                class="btn btn-sm btn-secondary"
                @click="abrir('list')"
              >
                Cadastro
              </button>
            </div>
          </div>
        </div>

        <div
          class="row mb-2"
          :style="{ display: view == 'list' ? 'block' : 'none' }"
        >
          <div class="col text-center d-flex justify-content-between">
            <input
              class="form-control"
              type="text"
              v-model="filtrar"
              @keyup="keyUpFiltrar"
              style="max-width: 30%"
            />
            <span class="mt-1">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="editarItem('')"
              >
                Novo
              </button>
            </span>
          </div>
        </div>

        <div
          class="row"
          :style="{ display: view == 'item' ? 'block' : 'none' }"
        >
          <div class="col col-12">
            <h2 class="text-center mt-3">
              {{ item._id !== "" ? "Editando item" : "Novo item" }}
            </h2>

            <h5 class="text-center mt-1 text-danger">
              {{ itemErro }}
            </h5>

            <div class="form p-4">
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Sofa Score</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    type="text"
                    @keyup="enterSalvarItem"
                    v-model="item.sofascore"
                  />
                </div>
              </div>

              <div class="form-group row mt-2">
                <label class="col-sm-12 col-form-label">William Hill</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    type="text"
                    @keyup="enterSalvarItem"
                    v-model="item.williamhill"
                  />
                </div>
              </div>
            </div>

            <button
              type="button"
              class="btn btn-primary mr-2"
              @click="salvarItem()"
            >
              Salvar
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="fecharItem(item._id)"
            >
              Cancelar
            </button>
          </div>
        </div>

        <div
          class="row"
          :style="{ display: view == 'list' ? 'block' : 'none' }"
        >
          <div class="col col-12">
            <table class="table mt-2">
              <thead class="table-dark">
                <tr>
                  <th class="text-left">Sofa Score</th>
                  <th class="text-left">William Hill</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="itemSofascore in itens" :key="itemSofascore._id">
                  <td class="text-left align-middle">
                    {{ itemSofascore.sofascore }}
                  </td>
                  <td class="text-left align-middle">
                    {{ itemSofascore.williamhill }}
                  </td>
                  <td class="align-middle text-right w-25">
                    <button
                      type="button"
                      @click="deleteItem(itemSofascore._id)"
                      class="btn btn-sm btn-primary mr-1"
                    >
                      Excluir
                    </button>
                    <button
                      type="button"
                      @click="editarItem(itemSofascore._id)"
                      class="btn btn-sm btn-primary"
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          class="row mb-2"
          :style="{ display: view == 'events' ? 'block' : 'none' }"
        >
          <div class="col d-flex justify-content-center">
            <h3>{{ itemEvento.nome }}</h3>
          </div>
        </div>

        <div
          class="row mb-2"
          :style="{ display: view == 'events' ? 'block' : 'none' }"
        >
          <div class="col d-flex justify-content-center">
            <input
              class="form-control"
              type="text"
              v-model="filtrarEvents"
              @keyup="keyUpFiltrarEvents"
              style="max-width: 30%"
            />
          </div>
        </div>

        <div
          class="row"
          :style="{ display: view == 'events' ? 'block' : 'none' }"
        >
          <div class="col col-12">
            <table class="table mt-2">
              <thead class="table-dark">
                <tr>
                  <th class="text-left">Id</th>
                  <th class="text-left">Event</th>
                  <th class="text-left">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="itemEvent in itensEvents" :key="itemEvent._id">
                  <td class="text-left align-middle">
                    <span
                      class="text-primary"
                      @dblclick="
                        editarEvento(itemEvent.eventId.replace('OB_EV', ''))
                      "
                      style="
                        cursor: pointer;
                        user-select: none;
                        -moz-user-select: none;
                        -webkit-user-select: none;
                        -ms-user-select: none;
                      "
                      >{{ itemEvent.eventId.replace("OB_EV", "") }}</span
                    >
                  </td>
                  <td class="text-left align-middle">
                    {{ itemEvent.eventName }}
                  </td>
                  <td class="text-left align-middle">
                    {{ formatDateTime(itemEvent.startDateTime) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "@/includes/util.js";
//const axios = require("axios");

import Dialog from "../components/Dialog.vue";

export default {
  name: "WilliamHill",
  components: { Dialog },
  methods: {
    async williamHillVincular() {
      //* Define a mensagem
      this.mensagem = "Carregando os dados... aguarde...";

      /*try {
        
        //* Manda processar a importacao
        await api.post("/evento/import/ws-r", {});

      } catch (errImport1) {
        console.log(errImport1);
      }*/

      try {
        //* Manda processar a importacao
        await api.get("/williamhill/vincular");
      } catch (errImport1) {
        console.log(errImport1);
      }

      //* Define a mensagem
      this.mensagem = "Importação concluída!";

      this.$emit("concluido");
    },
    async editarEvento(williamHillId) {
      var thisCall = this;

      if (this.itemEvento._id !== "") {
        await api.put("/williamhill/evento/" + this.itemEvento._id, {
          williamHillId: williamHillId,
        });
      }

      this.$emit("concluido");
      thisCall.fechar();
    },
    fechar() {
      this.mensagem = "";
      this.$refs.dialogWilliamHill.fechar();
    },
    abrir(view = "opcoes", idEvento = "") {
      this.mensagem = "";
      this.filtrar = "";
      this.filtrarEvents = "";
      this.view = view;
      this.$refs.dialogWilliamHill.abrir();

      if (view == "events") {
        this.itemEvento._id = idEvento;
        this.carregarItensEvents();
      } else if (view == "list") {
        this.carregarItens();
      }
    },
    keyUpFiltrar() {
      clearTimeout(this.timerFiltrar);

      var thisCall = this;

      this.timerFiltrar = setTimeout(function () {
        thisCall.carregarItens();
      }, 300);
    },
    keyUpFiltrarEvents() {
      clearTimeout(this.timerFiltrar);

      var thisCall = this;

      this.timerFiltrar = setTimeout(function () {
        thisCall.carregarItensEvents();
      }, 300);
    },
    async editarItem(_id) {
      this.item._id = "";
      this.item.sofascore = "";
      this.item.williamhill = "";
      this.itemErro = "";

      if (_id !== "") {
        let result = await api.get("/williamhill/sofascore/" + _id);

        if (result.data.erro == false) {
          if (result.data.itens.length > 0) {
            this.item._id = _id;
            this.item.sofascore = result.data.itens[0].sofascore;
            this.item.williamhill = result.data.itens[0].williamhill;
          }
        }
      }

      this.view = "item";
    },
    async deleteItem(_id) {
      await api.delete("/williamhill/sofascore/" + _id);
      this.carregarItens();
    },
    async fecharItem() {
      this.view = "list";
    },
    async salvarItem() {
      var thisCall = this;

      var result;

      //* Limpa os erros
      this.itemErro = "";

      if (this.item._id == "") {
        result = await api.post("/williamhill/sofascore", this.item);
      } else {
        result = await api.put(
          "/williamhill/sofascore/" + this.item._id,
          this.item
        );
      }

      if (result.data.erro == true) {
        this.itemErro = "Erro ao cadastrar, verifique os dados";
      } else {
        thisCall.carregarItens();
        this.view = "list";
      }
    },
    async enterSalvarItem(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.salvarItem();
      }
    },
    async carregarItens() {
      let result = await api.get(
        "/williamhill/sofascore" +
          (this.filtrar !== ""
            ? "?_all=" + encodeURIComponent(this.filtrar)
            : "")
      );

      if (result.data.erro == false) {
        this.itens = result.data.itens;
      }
    },
    async carregarItensEvents() {
      //* Verifica se deve carregar algum evento
      if (this.itemEvento._id !== "") {
        //* Carrega os dados do evento
        let resultEvento = await api.get("/evento/" + this.itemEvento._id);

        //* Verifica se encontrou e se nao deu erro
        if (
          resultEvento.data.erro == false &&
          resultEvento.data.itens.length > 0
        ) {
          this.itemEvento = resultEvento.data.itens[0];
        }
      }

      let result = await api.get(
        "/williamhill" +
          (this.filtrarEvents !== ""
            ? "?_all=" + encodeURIComponent(this.filtrarEvents)
            : "")
      );

      if (result.data.erro == false) {
        this.itensEvents = result.data.itens;
      }
    },
    formatDateTime(data) {
      return util.formatDateTime(data);
    },
  },
  data: function () {
    return {
      mensagem: "",
      itens: [],
      itensEvents: [],
      itemEvento: { _id: "", nome: "" },
      filtrar: "",
      filtrarEvents: "",
      timerFiltrar: 0,
      item: { _id: "", sofascore: "", williamhill: "" },
      itemErro: "",
      view: "list",
    };
  },
  async mounted() {},
};
</script>

<style>
</style>